import Resource from './Resource'

class RequestTrackingResource extends Resource {
    async getTracking(labId, requestId) {
        const response = await this.axios.get(`/clinical/laboratories/${labId}/requests/${requestId}/tracking`)
        return response.data
    }
}

export default new RequestTrackingResource()
